var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7896 32.7894C32.4372 33.1418 31.8658 33.1418 31.5134 32.7894L27.9631 29.2391C26.1461 30.2616 24.0922 30.8005 21.9991 30.7978C16.5428 30.7975 11.9274 27.2112 10.3745 22.2701C10.3191 22.0936 10.3192 21.9043 10.3749 21.7279C11.1206 19.3652 12.5644 17.2939 14.5035 15.7795L11.2098 12.4858C10.8574 12.1334 10.8574 11.562 11.2098 11.2096C11.5622 10.8572 12.1336 10.8572 12.486 11.2096L25.0313 23.7538C25.0403 23.7629 25.0493 23.7722 25.0579 23.7815L32.7896 31.5132C33.142 31.8656 33.142 32.437 32.7896 32.7894ZM26.6287 27.9047L24.3247 25.6006C23.6372 26.0443 22.8311 26.2856 22.0003 26.2856C20.8634 26.2856 19.7731 25.8339 18.9692 25.03C18.1653 24.2261 17.7137 23.1358 17.7137 21.9989C17.7137 21.1681 17.9549 20.362 18.3986 19.6745L15.791 17.067C14.1254 18.3114 12.8677 20.0289 12.1856 22C13.5899 26.0704 17.4543 28.993 21.9997 28.993L22.0009 28.993C23.6123 28.9952 25.1964 28.6202 26.6287 27.9047ZM19.727 21.003C19.5907 21.3141 19.5184 21.6528 19.5184 21.9989C19.5184 22.6572 19.7799 23.2884 20.2453 23.7539C20.7108 24.2193 21.342 24.4808 22.0003 24.4808C22.3464 24.4808 22.6852 24.4085 22.9962 24.2722L19.727 21.003ZM30.4562 26.1355C30.0589 25.8347 29.9807 25.2687 30.2816 24.8714C30.9411 24.0005 31.4582 23.0311 31.814 21.9995C30.4098 17.9288 26.5452 15.006 21.9997 15.006C21.3466 15.0055 20.6942 15.0664 20.0524 15.1877C19.5627 15.2803 19.0907 14.9584 18.9981 14.4687C18.9055 13.979 19.2274 13.507 19.7171 13.4144C20.4698 13.272 21.2343 13.2007 22.0004 13.2013C27.4566 13.2016 32.072 16.7878 33.6249 21.729C33.6802 21.9051 33.6802 22.094 33.6249 22.2701C33.2066 23.6006 32.5623 24.8491 31.7204 25.9609C31.4195 26.3582 30.8535 26.4364 30.4562 26.1355Z",
    fill: "#4D4D4D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideWhite);
export default __webpack_public_path__ + "static/media/hide-white.51bd51a2f56ad91f34945003162197cf.svg";
export { ForwardRef as ReactComponent };